import { subscribe } from '~/event-bus';
import { getTargets, on } from '~/helpers';

/**
 * General custom element helpers, such as target selectors and event management.
 */
export class HTMLCustomElement extends HTMLElement {
  events = [];

  constructor() {
    super();

    this.resetTargets();
  }

  /**
   * Returns elements related to the custom element.
   * @returns {ReturnType<typeof import('./helpers').getTargets>}
   */
  get targets() {
    return this.cachedTargets ?? {};
  }

  /**
   * Applies a self-cleaning event listener.
   * @param {Parameters<typeof import('helpers').on>} args - The `on` helper arguments.
   */
  on(...args) {
    this.events.push(on(...args));
  }

  /**
   * Applies a self-cleaning Event Bus listener.
   * @param {Parameters<typeof import('event-bus').subscribe>} args - The `on` helper arguments.
   */
  subscribe(...args) {
    this.events.push(subscribe(...args));
  }

  /**
   * Removes all self-cleaning event listeners.
   */
  removeEventListeners() {
    this.events.forEach((removeEvent) => {
      removeEvent();
    });

    /**
     * Clear the event state.
     */
    this.events = [];
  }

  /**
   * Queries the targets again.
   */
  resetTargets() {
    this.cachedTargets = getTargets(this);
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}
